import { getEasterDate } from './easter';
import { formatDateKey, getFirstSunday } from './date';

export function getCelebrations(year: number) {
  const easter = getEasterDate(year);
  const easterMonday = new Date(easter);
  easterMonday.setDate(easter.getDate() + 1);
  const mothersDay = getFirstSunday(year, 4); // May
  const fathersDay = getFirstSunday(year, 5); // June

  return new Map<string, string>([
    ['01-01', 'Naujųjų metų diena'],
    ['02-16', 'Lietuvos valstybės atkūrimo diena'],
    ['03-11', 'Lietuvos nepriklausomybės atkūrimo diena'],
    [formatDateKey(easter), 'Šventosios Velykos'],
    [formatDateKey(easterMonday), 'Antroji Šv. Velykų diena'],
    ['05-01', 'Tarptautinė darbo diena'],
    [formatDateKey(mothersDay), 'Motinos diena'],
    [formatDateKey(fathersDay), 'Tėvo diena'],
    ['06-24', 'Rasos ir Joninių diena'],
    ['07-06', 'Mindaugo karūnavimo diena'],
    ['08-15', 'Žolinė arba Švč. Mergelės Marijos ėmimo į dangų diena'],
    ['11-01', 'Visų Šventųjų diena'],
    ['11-02', 'Mirusiųjų atminimo (Vėlinių) diena'],
    ['12-24', 'Kūčių diena'],
    ['12-25', 'Šventosios Kalėdos'],
    ['12-26', 'Šventosios Kalėdos'],
  ]);
}
